var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.117 4H5.7215C4.617 4 4 5.03 4 6.1345V34.6345C4 35.739 4.617 36 5.7215 36H34.2215C35.326 36 36 35.739 36 34.6345V5.6345C36 4.53 35.2215 4 34.117 4ZM34 6V10.5H6V6H34ZM6 34V11.5H34V34H6Z",
    fill: "#7B00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91702 9.00024H8.91702C9.19352 9.00024 9.41702 8.77674 9.41702 8.50024C9.41702 8.22374 9.19352 8.00024 8.91702 8.00024H7.91702C7.64052 8.00024 7.41702 8.22374 7.41702 8.50024C7.41702 8.77674 7.64052 9.00024 7.91702 9.00024Z",
    fill: "#7B00FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 9.00024H11.917C12.1935 9.00024 12.417 8.77674 12.417 8.50024C12.417 8.22374 12.1935 8.00024 11.917 8.00024H10.917C10.6405 8.00024 10.417 8.22374 10.417 8.50024C10.417 8.77674 10.6405 9.00024 10.917 9.00024Z",
    fill: "#7B00FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.917 9.00024H14.917C15.1935 9.00024 15.417 8.77674 15.417 8.50024C15.417 8.22374 15.1935 8.00024 14.917 8.00024H13.917C13.6405 8.00024 13.417 8.22374 13.417 8.50024C13.417 8.77674 13.6405 9.00024 13.917 9.00024Z",
    fill: "#7B00FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7631 19.2472C15.5486 19.0722 15.2341 19.1047 15.0601 19.3187L12.0881 22.9602C11.9416 23.1387 11.9371 23.3952 12.0776 23.5792L15.0496 27.4797C15.1476 27.6087 15.2966 27.6767 15.4476 27.6767C15.5531 27.6767 15.6596 27.6437 15.7501 27.5742C15.9691 27.4072 16.0116 27.0932 15.8441 26.8737L13.1111 23.2872L15.8336 19.9507C16.0096 19.7367 15.9776 19.4217 15.7631 19.2472Z",
    fill: "#7B00FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8726 19.3311C24.7061 19.1121 24.3926 19.0686 24.1721 19.2371C23.9526 19.4041 23.9106 19.7181 24.0781 19.9376L26.8111 23.5236L24.0886 26.8606C23.9136 27.0746 23.9456 27.3896 24.1601 27.5636C24.2531 27.6396 24.3646 27.6766 24.4756 27.6766C24.6206 27.6766 24.7646 27.6136 24.8631 27.4926L27.8351 23.8506C27.9816 23.6716 27.9861 23.4156 27.8456 23.2316L24.8726 19.3311Z",
    fill: "#7B00FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.329 18.5755C18.2265 18.3185 17.936 18.1945 17.6795 18.295C17.4225 18.397 17.2975 18.688 17.399 18.9445L21.357 28.9035C21.435 29.1 21.623 29.219 21.822 29.219C21.8835 29.219 21.946 29.208 22.0065 29.184C22.2635 29.082 22.3885 28.791 22.287 28.5345L18.329 18.5755Z",
    fill: "#7B00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.69d84e5efd4c1e11dc16606b86f458ac.svg";
export { ForwardRef as ReactComponent };